/**
 * CAPEX & EE Calculator Configuration Routes
 *
 * Global admin pages for the CAPEX & Energy Efficiency calculator catalogue and parameters.
 */

import { lazy } from 'react';
import { ConfigLayout } from '@/features/administration/ui/ConfigLayout';

const CapexEeConfigPage = lazy(() => import('@/pages/capex-ee-config/CapexEeConfigPage'));

export const capexEeConfigRoutes = [
    {
        path: 'configuration/capex-ee-calculator',
        element: <ConfigLayout />,
        children: [
            {
                index: true,
                element: <CapexEeConfigPage />,
            },
        ],
    },
];
